<div class="expansion-panel-container">
  <mat-accordion>
    <mat-expansion-panel class="expansion-panel" [expanded]="isDefaultOpen" (opened)="togglePanel()" (closed)="togglePanel()">
      <mat-expansion-panel-header>
        <mat-panel-title [ngClass]="isTitleBold ? 'expansion-panel-title-bold' : 'expansion-panel-title-normal'">
          {{ title }}
        </mat-panel-title>
        <mat-panel-description *ngIf="description" class="expansion-panel-description">
            {{ description }} 
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ng-content></ng-content>
    </mat-expansion-panel>
  </mat-accordion>
</div>
